.userButton {
	display: flex;
	padding: var(--size-3) var(--size-4);
	gap: var(--size-4);
	align-items: center;
	font-weight: 600;
	background-color: transparent;
	border: none;
	border-radius: var(--radius-lg);
	transition:
		background-color var(--duration) ease,
		box-shadow var(--duration) ease;

	&:hover {
		background-color: light-dark(var(--gray-400), var(--gray-800));
	}
}

.settings {
	display: flex;
	flex-direction: column;
	gap: var(--size-8);
	width: 100%;
}

.logoutModal {
	display: flex;
	flex-direction: column;
	gap: var(--size-7);

	> form {
		display: flex;
		gap: var(--size-5);
		justify-content: flex-end;
	}
}
